import { RenderModalCtx } from 'datocms-plugin-sdk';
import { Canvas } from 'datocms-react-ui';
import RenderWebshopArticle from './RenderWebshopArticle';

type PropTypes = {
  ctx: RenderModalCtx;
};

function RenderWebshopArticlePlugin({ ctx }: PropTypes) {
  const width = ctx.parameters.width as number;
  const height = ctx.parameters.height as number;
  const language = "hu";
  const id = ctx.parameters.id as string;

  return <Canvas ctx={ctx}>
    <RenderWebshopArticle width={width} height={height} language={language} id={id} datoplugin={true} />
  </Canvas>
}

export default RenderWebshopArticlePlugin;